/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_TitleInputs */

const en_mk_team_flow_title = /** @type {(inputs: Mk_Team_Flow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the work. Check the results together.`)
};

const id_mk_team_flow_title = /** @type {(inputs: Mk_Team_Flow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugas dibagi. Hasil diperiksa bersama.`)
};

/**
* | output |
* | --- |
* | "Divide the work. Check the results together." |
*
* @param {Mk_Team_Flow_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_title = /** @type {((inputs?: Mk_Team_Flow_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_title(inputs)
	return en_mk_team_flow_title(inputs)
});